"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5656],{

/***/ 65656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nl": function() { return /* reexport */ GiftCardItem; },
  "pp": function() { return /* reexport */ MiniCart; },
  "ei": function() { return /* reexport */ MiniCartActions; },
  "Cd": function() { return /* reexport */ ProductItem; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./ui/components/Img.tsx
var Img = __webpack_require__(53579);
// EXTERNAL MODULE: ./ui/components/Price.tsx
var Price = __webpack_require__(81406);
;// CONCATENATED MODULE: ./ui/components/MiniCart/GiftCardItem.tsx





var GiftCardItem = function(param) {
    var amount = param.amount, imageUrl = param.imageUrl, recipientEmail = param.recipientEmail, recipientName = param.recipientName, senderName = param.senderName, message = param.message;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-32 mr-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
                    src: imageUrl,
                    alt: translate("giftCard")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-grow",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "font-bold pb-1 text-puma-black text-base leading-tight",
                                children: translate("digitalGiftCard")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "capitalize text-puma-black font-bold whitespace-nowrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                    amount: amount
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,css.tw)("text-xs xs:text-sm"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyValueRow, {
                                label: translate("recipientEmail"),
                                value: recipientEmail
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyValueRow, {
                                label: translate("recipientName"),
                                value: recipientName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyValueRow, {
                                label: translate("senderName"),
                                value: senderName
                            }),
                            message && /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyValueRow, {
                                label: translate("message"),
                                value: message
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var KeyValueRow = function(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "text-xs xs:text-sm flex flex-wrap break-all pb-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "capitalize text-puma-black-300",
                children: [
                    label,
                    ":\xa0"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: value
            })
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ./ui/content/ProductRecommender.tsx + 1 modules
var ProductRecommender = __webpack_require__(30664);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(69771);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./utils/longTermPreOrder.ts
var longTermPreOrder = __webpack_require__(50765);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./store/index.ts + 5 modules
var store = __webpack_require__(57023);
// EXTERNAL MODULE: ./ui/components/GiftWithPurchase/utils/isTherePromosButNotASinglePromoClaimed.ts
var isTherePromosButNotASinglePromoClaimed = __webpack_require__(11222);
;// CONCATENATED MODULE: ./ui/components/MiniCart/MiniCart.tsx














var MiniCart = function() {
    var ref = (0,useCart/* useCart */.j)(), cart = ref.cart, cartResult = ref.cartResult;
    var ref1 = (0,useSiteConfig/* useSiteConfig */.N)(), enablePopularity = ref1.staticFeatures.enablePopularity, shoppingCartItemType = ref1.shoppingCartItemType;
    var setModalOpen = (0,store/* useModalsOpenStore */.wQ)().setModalOpen;
    var ref2 = (0,useMiniCart/* useMiniCart */.lm)(), products = ref2.products, closeMiniCart = ref2.closeMiniCart, mixedCartNotAllowed = ref2.mixedCartNotAllowed, tryingToOpenMiniCartFromGWP = ref2.tryingToOpenMiniCartFromGWP;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    // Make sure the miniCart open boolean in context is
    // set to false whenever the component is unmounted
    (0,react.useEffect)(function() {
        return function() {
            return closeMiniCart();
        };
    }, [
        closeMiniCart
    ]);
    (0,react.useEffect)(function() {
        // if we not are trying to open the miniCart from GWP and have unclaimed products in the giftWithPurchases
        // true -> redirect to open GWPModal instead of miniCart
        if (!tryingToOpenMiniCartFromGWP && (0,isTherePromosButNotASinglePromoClaimed/* isTherePromosButNotASinglePromoClaimed */.Q)({
            cart: cart
        })) {
            closeMiniCart();
            setModalOpen("GWPModal", true);
        }
    // false -> just open the miniCart as usual
    }, [
        cart,
        closeMiniCart,
        setModalOpen,
        tryingToOpenMiniCartFromGWP
    ]);
    var addedToWishlist = !!(products === null || products === void 0 ? void 0 : products.find(function(p) {
        return p.__typename === "WishListItem";
    }));
    var showAmazonPayButton = !cartResult.fetching && !cartResult.error && !mixedCartNotAllowed && (!(0,longTermPreOrder/* isLongTermPreOrder */.j)(cart) || (0,longTermPreOrder/* isLongTermPreOrderPaymentMethod */.L)(cart, constants/* PaymentMethod.AMAZON_PAY */.XL.AMAZON_PAY));
    var idsForRecommendations = products === null || products === void 0 ? void 0 : products.reduce(function(acc, curr) {
        if ("product" in curr) {
            var ref;
            return (0,_to_consumable_array/* default */.Z)(acc).concat([
                (ref = curr) === null || ref === void 0 ? void 0 : ref.product.masterId, 
            ]);
        }
    }, []);
    var recommenderGridTemplateColumns = "repeat(@{itemCount}, calc(33.333% - 10px))";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogRoot */.GRm, {
            defaultOpen: true,
            size: "sm",
            align: "start",
            justify: "end",
            dataTestId: "minicart-added-to",
            onOpenChange: function(open) {
                return open === false ? closeMiniCart() : null;
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogContent */.cZJ, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogHeader */.fKu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogHeading */.EtB, {
                            children: translate(addedToWishlist ? "miniWishListAddedToWishlist" : "miniCartAddedToCart")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogBody */.a7O, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                className: "overflow-y-auto max-h-[256px]",
                                gap: "sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Separator */.Z0O, {
                                        role: "none",
                                        gap: "none"
                                    }),
                                    products === null || products === void 0 ? void 0 : products.map(function(product, idx) {
                                        if (product.__typename === "ProductCartItem" || addedToWishlist) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem, {
                                                        type: shoppingCartItemType,
                                                        product: product
                                                    }, "product-".concat(product.id, "-").concat(idx)),
                                                    enablePopularity && product.__typename === "ProductCartItem" && !product.bonusItemId && product.popularityCount != null && product.popularityCount !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-center mx-auto",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Text */.xvT, {
                                                            weight: "bold",
                                                            size: "xs",
                                                            transform: "uppercase",
                                                            children: [
                                                                product.popularityCount,
                                                                "+",
                                                                " ",
                                                                translate("popularityMessage")
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, "product-item-".concat(product.id, "-").concat(idx));
                                        }
                                        if (product.__typename === "GiftCardCartItem") {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftCardItem, {
                                                amount: product.amount,
                                                imageUrl: product.imageUrl,
                                                recipientEmail: product.recipientEmail,
                                                recipientName: product.recipientName,
                                                senderName: product.senderName,
                                                message: product.message
                                            }, "giftcard-".concat(product.id, "-").concat(idx));
                                        }
                                        return null;
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Separator */.Z0O, {
                                role: "none",
                                gap: "sm"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCartActions, {
                                addedToWishlist: addedToWishlist,
                                productCount: cart === null || cart === void 0 ? void 0 : cart.productCount,
                                giftWithPurchases: cart === null || cart === void 0 ? void 0 : cart.giftWithPurchases,
                                mixedCartNotAllowed: mixedCartNotAllowed,
                                showAmazonPayButton: showAmazonPayButton,
                                closeMiniCart: closeMiniCart
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Separator */.Z0O, {
                                gap: "sm"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductRecommender/* ProductRecommender */.S, {
                                type: "itemAddedPopup",
                                ids: idsForRecommendations,
                                displayRecommendations: !!products,
                                gridTemplateColumnConfig: {
                                    mobile: recommenderGridTemplateColumns,
                                    tablet: recommenderGridTemplateColumns,
                                    desktop: recommenderGridTemplateColumns
                                },
                                stackProductInfo: true,
                                isMiniCart: true
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./ui/components/ApplePayButton.tsx
var ApplePayButton = __webpack_require__(74503);
// EXTERNAL MODULE: ./ui/components/GooglePayButton.tsx
var GooglePayButton = __webpack_require__(69192);
// EXTERNAL MODULE: ./ui/components/PayPalButton.tsx
var PayPalButton = __webpack_require__(49246);
// EXTERNAL MODULE: ./ui/components/TermsAndConditions.tsx + 3 modules
var TermsAndConditions = __webpack_require__(99750);
// EXTERNAL MODULE: ./ui/components/TermsAndConditionsBackup.tsx
var TermsAndConditionsBackup = __webpack_require__(95459);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./ui/components/AmazonPayV2Button.tsx
var AmazonPayV2Button = __webpack_require__(94052);
// EXTERNAL MODULE: ./ui/components/AdyenApplePayButton.tsx
var AdyenApplePayButton = __webpack_require__(64844);
// EXTERNAL MODULE: ./ui/components/MixedCartErrorMessage.tsx
var MixedCartErrorMessage = __webpack_require__(56620);
// EXTERNAL MODULE: ./ui/components/GiftWithPurchase/OldDesign/index.tsx + 16 modules
var OldDesign = __webpack_require__(12656);
// EXTERNAL MODULE: ./ui/components/GiftWithPurchase/NewDesign/index.ts + 10 modules
var NewDesign = __webpack_require__(41347);
;// CONCATENATED MODULE: ./ui/components/MiniCart/MiniCartActions.tsx





















var showPaymentMethods = function(country) {
    return ![
        constants/* SUPPORTED_COUNTRY.US */.bM.US,
        constants/* SUPPORTED_COUNTRY.CA */.bM.CA
    ].includes(country);
};
var MiniCartActions = function(param) {
    var addedToWishlist = param.addedToWishlist, giftWithPurchases = param.giftWithPurchases, productCount = param.productCount, mixedCartNotAllowed = param.mixedCartNotAllowed, showAmazonPayButton = param.showAmazonPayButton, closeMiniCart = param.closeMiniCart;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var country = (0,useSiteConfig/* useSiteConfig */.N)().country;
    var isGiftWithPurchaseNewDesign = (0,useFeature/* useFeature */.S)("GIFT_WITH_PURCHASE_NEW_DESIGN");
    var setModalOpen = (0,store/* useModalsOpenStore */.wQ)().setModalOpen;
    if (addedToWishlist) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-test-id": "minicart-actions",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkCta */.NIR, {
                dataTestId: "minicart-wishlist-view",
                label: t("miniWishlistViewWishlist"),
                href: "/wishlist"
            }, "wishlist")
        });
    }
    var GWPCalloutButton = isGiftWithPurchaseNewDesign ? NewDesign/* GWPNewDesign.CalloutButton */.k.CalloutButton : OldDesign/* GWPOldDesign.CalloutButton */.f.CalloutButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-test-id": "minicart-actions",
        className: "grid gap-3 mt-4",
        children: [
            (0,isTherePromosButNotASinglePromoClaimed/* isTherePromosButNotASinglePromoClaimed */.Q)({
                giftWithPurchases: giftWithPurchases
            }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GWPCalloutButton, {
                onClick: function() {
                    setModalOpen("GWPModal", true);
                    closeMiniCart();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsAndPaymentMethods, {
                productCount: productCount,
                showPaymentMethods: showPaymentMethods(country),
                mixedCartNotAllowed: mixedCartNotAllowed,
                showAmazonPayButton: showAmazonPayButton
            })
        ]
    });
};
var TermsAndConditionsAndPaymentMethods = function(props) {
    if (props.showPaymentMethods) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TermsAndConditions/* default */.Z, {
            page: "tacOnItemAddedPopup",
            backupContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsBackup/* default */.Z, {}),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewCartCheckoutButtons, {
                    productCount: props.productCount,
                    mixedCartNotAllowed: props.mixedCartNotAllowed
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PayPalButton/* PayPalButton */.q, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplePayButton/* ApplePayButton */.x, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdyenApplePayButton/* AdyenApplePayButton */.D, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePayButton/* GooglePayButton */.I, {
                    buttonType: "pay"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: props.showAmazonPayButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(AmazonPayV2Button/* AmazonPayV2PayButton */.lj, {
                        style: {
                            height: "60px",
                            width: "200px",
                            justifySelf: "center"
                        }
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions/* default */.Z, {
        page: "tacOnItemAddedPopup",
        backupContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsBackup/* default */.Z, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewCartCheckoutButtons, {
            productCount: props.productCount,
            mixedCartNotAllowed: props.mixedCartNotAllowed
        })
    });
};
var ViewCartCheckoutButtons = function(props) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var isMobile = (0,media/* getIsMobile */.W)();
    var separateViewAndCheckoutButtons = (0,useFeature/* useFeature */.S)("MINICART_SEPARATE_VIEW_AND_CHECKOUT_BUTTONS");
    var cartCount = props.productCount === undefined ? 0 : Number(props.productCount);
    var viewCartText = separateViewAndCheckoutButtons ? t("miniCartViewCart", {
        count: cartCount
    }) : t("miniCartViewCartAndCheckout", {
        count: cartCount
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,twind.tw)("grid gap-3 mobile:grid-cols-1", separateViewAndCheckoutButtons ? "grid-cols-2" : "grid-cols-1"),
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(MixedCartErrorMessage/* MixedCartErrorMessage */.U, {
                mixedCartNotAllowed: props.mixedCartNotAllowed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkCta */.NIR, {
                dataTestId: "minicart-cart-link",
                label: viewCartText,
                href: "/cart",
                className: "flex-grow",
                variant: separateViewAndCheckoutButtons ? "secondary" : "primary",
                size: "lg",
                onClick: function() {
                    (0,analytics/* event */.B)(analytics/* AnalyticsEvents.MINICART */._q.MINICART, {
                        domevent: "button clicked",
                        domlabel: "cart page"
                    });
                    (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                        event_name: analytics/* AnalyticsEvents.MINICART */._q.MINICART,
                        event_params: {
                            user_action: "view cart/checkout"
                        }
                    });
                }
            }, "cart"),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(MixedCartErrorMessage/* MixedCartErrorMessage */.U, {
                mixedCartNotAllowed: props.mixedCartNotAllowed
            }),
            separateViewAndCheckoutButtons && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkCta */.NIR, {
                dataTestId: "minicart-checkout-link",
                label: t("checkout"),
                href: "/checkout",
                className: "flex-grow",
                variant: "primary",
                size: "lg",
                dimmed: props.mixedCartNotAllowed,
                onClick: function(e) {
                    if (props.mixedCartNotAllowed) {
                        e.preventDefault();
                        return false;
                    }
                    (0,analytics/* event */.B)(analytics/* AnalyticsEvents.MINICART */._q.MINICART, {
                        domevent: "button clicked",
                        domlabel: "checkout"
                    });
                    (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                        event_name: analytics/* AnalyticsEvents.MINICART */._q.MINICART,
                        event_params: {
                            user_action: "view cart/checkout"
                        }
                    });
                }
            }, "checkout")
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ./sites/types.ts
var types = __webpack_require__(81526);
// EXTERNAL MODULE: ./utils/isNotNullish.ts
var isNotNullish = __webpack_require__(50597);
// EXTERNAL MODULE: ./ui/components/ProductPrice/ProductPrice.tsx + 2 modules
var ProductPrice = __webpack_require__(42413);
;// CONCATENATED MODULE: ./ui/components/CartAppliedProductPromotions.tsx




var CartAppliedProductPromotions = function(param) {
    var product = param.product, className = param.className;
    var ref;
    var displayPromoAppliedPromotion = (0,useFeature/* useFeature */.S)("DISPLAY_PROMO_APPLIED_PROMOTION");
    if (!displayPromoAppliedPromotion || (product === null || product === void 0 ? void 0 : product.__typename) !== "ProductCartItem" || !(product === null || product === void 0 ? void 0 : (ref = product.adjustments) === null || ref === void 0 ? void 0 : ref.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,twind.tw)("uppercase text-puma-red text-xs", className),
        children: product.adjustments.map(function(x) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                children: (ref = x.promotion) === null || ref === void 0 ? void 0 : ref.calloutMessage
            }, x.promotionId);
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/MiniCart/ProductItem.tsx










var ProductItem = function(param) {
    var product = param.product, type = param.type;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref11 = (0,useSiteConfig/* useSiteConfig */.N)(), showHeaderSubHeaderProductDetail = ref11.staticFeatures.showHeaderSubHeaderProductDetail;
    var imageUrl = product.personalizationImageURL || ((ref = product.product) === null || ref === void 0 ? void 0 : ref.imageUrl) || ((ref1 = product.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.href);
    var imageAlt = ((ref4 = product.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.images) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.alt) || "".concat(product.product.name, ", ").concat(product.product.colorName);
    var isSecondaryType = types/* ComponentType.SECONDARY */.r.SECONDARY == type;
    var isSalePriceElapsed = (ref7 = product === null || product === void 0 ? void 0 : product.product.productPrice) === null || ref7 === void 0 ? void 0 : ref7.isSalePriceElapsed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex",
        "data-test-id": "product-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-32 mr-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
                    src: imageUrl,
                    alt: imageAlt
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-grow",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "font-bold text-puma-black text-base leading-tight ".concat(isSecondaryType ? "mb-4" : ""),
                                "data-test-id": "product-item-name",
                                children: showHeaderSubHeaderProductDetail ? product.product.header : product.product.name
                            }),
                            showHeaderSubHeaderProductDetail && product.product.subHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "w-full text-base text-puma-gray-60 line-clamp-2",
                                children: product.product.subHeader
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartAppliedProductPromotions, {
                        product: product,
                        className: "my-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-puma-black-300 text-xs sm:text-sm",
                                                "data-test-id": "product-item-color-label",
                                                children: [
                                                    translate("color"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs sm:text-sm",
                                                "data-test-id": "product-item-color-name",
                                                children: product.product.colorName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-puma-black-300 text-xs sm:text-sm",
                                                "data-test-id": "product-item-size-label",
                                                children: [
                                                    translate("size"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs sm:text-sm",
                                                "data-test-id": "product-item-size-name",
                                                children: product.product.size.label
                                            })
                                        ]
                                    }),
                                    (product === null || product === void 0 ? void 0 : product.personalizationName) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-puma-black-300 text-xs sm:text-sm",
                                                children: [
                                                    translate("name"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs sm:text-sm",
                                                children: product.personalizationName
                                            })
                                        ]
                                    }) : null,
                                    (product === null || product === void 0 ? void 0 : product.personalizationNumber) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-puma-black-300 text-xs sm:text-sm",
                                                children: [
                                                    translate("number"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs sm:text-sm",
                                                children: product.personalizationNumber
                                            })
                                        ]
                                    }) : null,
                                    product.personalizationSurcharge && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-puma-black-300 text-xs sm:text-sm",
                                                children: [
                                                    translate("customizationCost"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs sm:text-sm",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                                    amount: product.personalizationSurcharge
                                                })
                                            })
                                        ]
                                    }),
                                    product.__typename === "ProductCartItem" && product.customizationName && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-puma-black-300 text-xs sm:text-sm",
                                                children: [
                                                    translate("name"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs sm:text-sm",
                                                children: product.customizationName
                                            })
                                        ]
                                    }),
                                    product.__typename === "ProductCartItem" && product.customizationNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-puma-black-300 text-xs sm:text-sm",
                                                children: [
                                                    translate("number"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs sm:text-sm",
                                                children: product.customizationNumber
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col font-bold w-full ".concat(isSecondaryType ? "mt-4" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* ProductPrice */.jF, (0,_object_spread/* default */.Z)({
                                    price: {
                                        amount: (ref8 = product.product.productPrice) === null || ref8 === void 0 ? void 0 : ref8.price,
                                        salePrice: (ref9 = product.product.productPrice) === null || ref9 === void 0 ? void 0 : ref9.salePrice,
                                        promotionPrice: (ref10 = product.product.productPrice) === null || ref10 === void 0 ? void 0 : ref10.promotionPrice,
                                        personalizationPrice: (0,isNotNullish/* isNotNullish */.l)(product.personalizationPrice) ? parseFloat(product.personalizationPrice) : undefined,
                                        isSalePriceElapsed: isSalePriceElapsed
                                    },
                                    compact: true,
                                    isMinicart: true
                                }, ProductPrice/* MINICART_PRICE_STRATEGY */.hG))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/MiniCart/index.ts






/***/ })

}]);